"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  background: #FFF;
  margin-bottom: 25px;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
`;
exports.Header = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  padding: 14px 15px 7px;
`;
exports.HeaderText = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;
exports.Title = styled_components_1.default.div `
  font-size: 16px;
  font-weight: bold;
`;
exports.Subtitle = styled_components_1.default.div `
  font-size: 16px;
`;
exports.BadgeContainer = styled_components_1.default.div `
  align-items: flex-end;
  margin-left: 0.5rem !important;
`;
exports.Content = styled_components_1.default.div `
  padding: 15px;
`;
